class TSHeader extends HTMLElement {
  constructor() {
    super();

    this.mobileMenu = this.querySelector("#MobileMenu");
    this.allAnnouncementsHeight = 0;
    this.isLoading = false;

    this.addEventListener('click', this.onClick.bind(this));
    
    this.calcHeader();
    window.addEventListener('scroll', () => {
      this.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);
    });
  }
  
  calcHeader() {
		const headerObserver = new ResizeObserver(() => {
			this.headerHeight = this.getBoundingClientRect().height;
			document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);

      const announcements = document.querySelectorAll(".ts-announcement, .ts-timer");
      this.allAnnouncementsHeight = Math.max(Array.from(announcements).reduce((sum, el) => {
        return sum + el.offsetHeight;
      }, 0), 1);
      
      this.classList.toggle('sticky', window.scrollY >= this.allAnnouncementsHeight);
		});

		headerObserver.observe(this);
	}

  onClick(event) {
    if (event.target.hasAttribute("data-action")) {
      switch (event.target.dataset.action) {
        case "menu-toggle":
          this.classList.toggle("open");
          if (document.documentElement.style.overflow === "hidden") {
            document.documentElement.style.overflow = null;
          } else {
            document.documentElement.style.overflow = "hidden";
          }
          break;
        case "menu-close":
          this.classList.remove('open');
          document.documentElement.style.overflow = null;
          break;;
      }
    }
  }
}

customElements.define("ts-header", TSHeader)